import React, { useEffect, useState } from "react";
import { Button, Col, Container, Row } from "react-bootstrap";
import { Combo } from "../combos/Combo";
import { DatePickerGeo } from "../../common/DatePickerGeo";
import { utils, writeFileXLSX } from "xlsx";
import getDatos from "../../../services/getDatos";
import { TableReporteOpenData } from "../../common/TableReporteOpenData";
import { Pagination } from "../../common/Pagination";
import consultarInfoToken from "../../../services/consultarInfoToken";

const initialStateFiltros = {
  dateRange: [null, null],
  origen: "-1",
  tipo: "-1",
  recurso: "-1",
  page: 1,
  rowPerPage: 15,
};
export default function EstadisticasDatosAbiertos({
  combosFiltros,
  idComponente,
  setLoad,
  navigate,
}) {
  const [currentPage, setCurrentPage] = useState(1);
  const [dataReporteXlsx, setDataReporteXlsx] = useState([]);
  const [dataReporte, setDataReporte] = useState({
    data: [],
    totalRows: 0,
  });
  const [filtrosReportes, setFiltrosReportes] = useState(initialStateFiltros);

  useEffect(() => {
    setFiltrosReportes((prev) => {
      return { ...prev, page: currentPage, rowPerPage: 15 };
    });
  }, [currentPage]);

  useEffect(() => {
    listarEstadisticas();
  }, [combosFiltros]);

  const onChangeFiltros = (target, type) => {
    if (type === "date") {
      setFiltrosReportes((prev) => {
        return { ...prev, dateRange: target };
      });

      return;
    }

    if (type === "combo") {
      const { value, name } = target;

      return setFiltrosReportes((prev) => {
        return { ...prev, [name]: value };
      });
    }
  };

  function changePage(page) {
    setCurrentPage(page);
    listarEstadisticas(page);
  }

  const listarEstadisticas = async (page = 1, clear) => {
    let infoToken = await consultarInfoToken();
    if (infoToken.idUsuario === 0 || !infoToken.idUsuario) {
      navigate("/", { replace: true });
    }
    setFiltrosReportes((prev) => {
      return { ...prev, page: page };
    });

    setLoad(true);

    let jsonFiltros = { ...filtrosReportes };
    if (clear) {
      jsonFiltros = { ...initialStateFiltros };
    }
    try {
      filtrosReportes.page = page;

      const response = await getDatos(
        "atributos/estadisticas/openData",
        jsonFiltros
      );

      setDataReporte(response);
      setLoad(false);

      setDataReporteXlsx(
        response.data.resultCountYReporteEstadistica.map((estadistica) => {
          return {
            NombreFuenteDato: estadistica.nombre_fuente_dato,
            NombreTematica: estadistica.nombre_tematica,
            FechaRegistro: estadistica.fecha_registro,
            OrigenEstadistica: estadistica.origen_estadistica_txt,
            TipoEstadistica: estadistica.tipo_estadistica,
            NombreCompletoUsuario: estadistica.nombre_completo,
            CorreoUsuario: estadistica.email,
            FormatoDecarga: estadistica.formato,
            Longitud: estadistica.longitud,
            Latitud: estadistica.latitud,
            Pais: estadistica.pais,
            Ciudad: estadistica.ciudad,
          };
        })
      );
    } catch (error) {
      setLoad(false);

      return false;
    }
  };

  const exportarXLSX = async () => {
    let infoToken = await consultarInfoToken();
    if (infoToken.idUsuario === 0 || !infoToken.idUsuario) {
      navigate("/", { replace: true });
    }
    try {
      const ws = utils.json_to_sheet(dataReporteXlsx);
      const wb = utils.book_new();

      utils.book_append_sheet(wb, ws, "Reporte estadistico");

      const configCols = dataReporteXlsx.map((estadistica) => {
        return { wch: 30 };
      });

      ws["!cols"] = configCols;

      writeFileXLSX(wb, "ReporteEstadisticoDatosAbiertos.xlsx");
    } catch (error) {
      alert("No se puede generar el reporte");
      return false;
    }
  };

  const limpiarFiltros = () => {
    setFiltrosReportes(initialStateFiltros);
    setCurrentPage(1);
    listarEstadisticas(1, true);
  };
  return (
    <Container>
      <Row>
        <Col lg={3} md={4} sm={6} xs={6}>
          <DatePickerGeo
            stateFather={filtrosReportes.dateRange}
            onChangeDatePicker={onChangeFiltros}
          />
        </Col>
        <Col lg={3} md={4} sm={6} xs={6}>
          <Combo
            value={filtrosReportes.origen}
            nameCombo={"origen"}
            onChangeCombo={({ target }) => onChangeFiltros(target, "combo")}
            dataOption={combosFiltros.resultOrigen.map((origen) => {
              return {
                id_combo: origen.id_origen,
                nombreOption: origen.nombre_origen,
              };
            })}
            titleLabel={"Origen"}
          />
        </Col>

        <Col lg={3} md={4} sm={6} xs={6}>
          <Combo
            value={filtrosReportes.tipo}
            nameCombo={"tipo"}
            onChangeCombo={({ target }) => onChangeFiltros(target, "combo")}
            dataOption={combosFiltros.resultTipo.map((tipo) => {
              return {
                id_combo: tipo.id_tipo,
                nombreOption: tipo.nombre_tipo,
              };
            })}
            titleLabel={"Tipo"}
          />
        </Col>

        <Col lg={3} md={4} sm={6} xs={6}>
          <Combo
            value={filtrosReportes.recurso}
            nameCombo={"recurso"}
            onChangeCombo={({ target }) => onChangeFiltros(target, "combo")}
            dataOption={combosFiltros.resultFuenteDato.map((fuenteDato) => {
              return {
                id_combo: fuenteDato.id_fuente_dato,
                nombreOption: fuenteDato.nombre,
              };
            })}
            titleLabel={"Recurso"}
          />
        </Col>

        <Col lg={12} md={8} sm={12} xs={12}>
          <div className="container-buttons-estadisticas datos-abiertos">
            <button
              style={{ marginRight: "auto" }}
              className="btn-principal btn-estadisticas mb-3"
              onClick={(e) => exportarXLSX()}
            >
              Descargar estadística
            </button>
            <button
              className="btn-aux btn-estadisticas mb-3"
              onClick={(e) => limpiarFiltros()}
            >
              Limpiar
            </button>
            <button
              className="btn-principal btn-estadisticas mb-3"
              onClick={(e) => listarEstadisticas()}
            >
              Buscar
            </button>
          </div>
        </Col>
      </Row>

      <div className="flex-table_geomedellin mt-2" id="tablaEstadisticas">
        <TableReporteOpenData
          data={dataReporte.data.resultDataEstadistica ?? []}
        />
      </div>
      {dataReporte.totalRows > 0 ? (
        <Row>
          <Col sm={12}>
            <Pagination
              totalRows={dataReporte.totalRows}
              rowPerPage={15}
              currentPage={currentPage}
              setCurrentPage={changePage}
              idComponente={idComponente}
              className={"mt-3 px-2"}
            />
          </Col>
        </Row>
      ) : (
        <></>
      )}
    </Container>
  );
}
